import { Pipe, PipeTransform } from '@angular/core'
import { ChatMessageGroup, ChatMessageModel } from '@shared/models/messenger/messenger.model'
import dayjs from 'dayjs'
import { groupBy, map as lodashMap, sortBy } from 'lodash-es'

@Pipe({
  name: 'chatMessageListGroup',
  pure: false,
  standalone: false,
})
export class ChatMessageListGroupPipe implements PipeTransform {
  transform(items: ChatMessageModel[]): ChatMessageGroup[] {
    const occurrenceDay = function (chatMessage: ChatMessageModel): string {
      return dayjs(chatMessage.createdAt).tz().startOf('day').format()
    }

    const groupToDay = (messages: ChatMessageModel[], day: string): ChatMessageGroup => {
      return {
        day: day,
        chatMessageList: messages,
      }
    }

    const result = groupBy<ChatMessageModel>(items.filter(Boolean), occurrenceDay)
    const mappedResult = lodashMap(result, groupToDay)
    return sortBy(mappedResult, 'day')
  }
}
